
export const past2021 = {
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    titleImg: require('@/assets/transSave/resource/image/9y/e8/9yy03c9cb2ba0b92e339671aa132f6e8.png'),
    mobileTitleImg: require('@/assets/transSave/resource/image/96/e9/96bcc073ba4a6804d0992345c43e34e9.png'),
    intro: [
      '第三届大赛自8月20日启动赛事招募，采用线上线下协同挑战模式，吸引了来自 130+ 所海内外知名高校共计800 余名学生参赛，覆盖从本科到博士等各个学历层次。在众多兼具创意和实践价值的优秀作品中，经过评审团队的重重筛选，20 支队伍入围决赛。',
      '11月6日-7日，20 支队伍在深圳湾创新广场发布中心进行现场编程马拉松及路演答辩，最终有 6 支队伍脱颖而出，获得双赛道前三甲。11月8日，大赛颁奖典礼暨杨强教授主题分享成功举办，入围团队参与了微众体验空间参访、颁奖典礼及杨强教授主题分享等环节活动。至此，历时 80 余天的 FinTechathon 2021 圆满结束。'
    ],
    poster: require('@/assets/transSave/resource/image/16/8e/16533dfe814e00ae19fd3b560193228e.jpg'),
    video: 'https://v-blog.csdnimg.cn/asset/33ec6883e48a6b115ee6b018cc8f3fc4/7ee4eea7780f111526799f7e5e1656e2.mp4'
  },

  ai: {
    title: '人工智能作品',
    subTitle: 'FINTECHATHON',
    height: '338px',
    content: [
      {
        imgUrl: require('@/assets/transSave/resource/image/9e/d4/9e3c83f0yy397328565cd3d2674977d4.jpg'),
        worksname: 'HBE',
        teamName: '第一名',
        desc: '面向学生心理健康的预防监测系统——基于 FATE 平台内卷时代来临，焦虑无处不在。心理健康关乎个人发展，结合学生个体心理健康防控的实际需求，本作品结合联邦学习保护隐私的优势，打造一个安全科学的多模态信息预测的平台，推进学生与健康的“最后一公里”，未来将联合更多机构为更广人群提供预测诊疗服务。'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/c3/70/c3615f7aa6c96ebae5d14fb0b4508670.jpg'),
        worksname: 'AIFT PLATFORM',
        teamName: '第二名',
        desc: 'FUT 一站式联邦营销。联邦营销一站式平台，FUT（Find U Together），提供简单易用的联邦学习算法流程帮助多方企业找到目标客户，并集成多种自动化营销产品接口；同时实现多方企业数据交易定价机制，奖励达成联邦学习任务的企业。FUT 平台实现了客户一站式营销场景应用，通过定价机制吸引企业参与联邦学习任务，为精准营销奠定基础。'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/4f/f7/4f8fa0641720e2ea6570254c98a8eaf7.jpg'),
        worksname: '仙交涵英',
        teamName: '第三名',
        desc: '基于联邦学习的智能保险经纪人。团队设计并实现了一种基于联邦学习技术并使用了文本分析技术的智能保险经纪人应用，该应用创新性的使用保险经纪人模式。相对于传统保险咨询流程，该应用能智能地优化用户的体验和最大化地保护用户的个人数据隐私。'
      }
    ]
  },

  blockchain: {
    title: '区块链作品',
    subTitle: 'FINTECHATHON',
    height: '398px',
    content: [
      {
        imgUrl: require('@/assets/transSave/resource/image/d7/ec/d79df0f08f8847c59e996e2db29141ec.jpg'),
        worksname: '关山口男子职业技术学院联创分部',
        teamName: '第一名',
        desc: '医链——面向隐私保护的医药大数据可信流转溯源解决方案。医链，构建全时空维度视图的“链”上医疗平台。从隐私保护出发，基于密钥可重新随机化的代理重加密、零知识证明与聚合签名，提出健康记录共享方案与药企供应链溯源⽅案，⼀站式解决异地复诊、取药、授权、溯源等问题，实现健康记录可信共享，加速医药数字化⽣态落地，为医疗⼤数据价值挖掘做技术背书。'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/a1/6e/a16fbd8de66fd8d74a4570cf752b036e.jpg'),
        worksname: '安产链队',
        teamName: '第二名',
        desc: '安产链——链上安全生产监督治理平台。安产链创新性地将区块链应用于安全生产领域，建立提供可监管隐私保护的分布式统一数据共享和信用体系，实现对安评过程的强制随机审查和精确到个人的细粒度精准监管，切实解决安评行业“两虚假、两出借、监管难”三大痛点问题，以区块链为武器维护人民群众的生命财产安全。 学习任务，为精准营销奠定基础。'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/83/f5/8372aa4ea03fdc8d5b9fd12d7d0fb6f5.jpg'),
        worksname: '上园村小红果',
        teamName: '第三名',
        desc: '亿点爱公益筹款区块链平台。近年来网络公益筹款平台层出不穷，但普遍存在监管制度不完善、个人隐私无法保护、个人行为无法约束等问题。因此本作品旨在通过区块链构建公益众筹平台，利用隐私保护技术实现安全可信存储，保护用户个人隐私的同时有效防止虚假筹款和善款挪用，以此促进互联网公益众筹行业健康有序的发展。'
      }
    ]
  }
}
